<template>
	<div class="index">
		<div class="topbanner" ref='yuansu'>
			<router-link tag="a" :to="{name:'introduce'}">
				<img src="../static/4.png" alt="">
			</router-link>
		</div>
		<div class="imgtox">
			<p class="title" style="top: -27px;">
				<span>展览介绍</span>
				<em style="top:21px;"></em>
			</p>
		</div>
		<div class="swiper-container">
		    <div class="swiper-wrapper">
		    	<div class="swiper-slide">
		    		<router-link tag="a" :to="{name:'shoud'}">
		    			<img src="../static/3.png" alt="">
		    		</router-link>
		    		<div class="towTit">
		    			<!-- <p style="font-size:20px;color:#d4e5a7;margin-bottom:10px;color:#c4d790;font-weight:600;">第一部分</p>
		    			<p style="font-size:20px;color:#96caee;margin-bottom:10px;color:#80b6db;font-weight:600;">一座地中海古城</p>
		    			<span style="display:inline-block;width:75%;border-bottom:2px solid #2e3648;"></span>
		    			<span style="display:inline-block;width:75%;border-bottom:1px solid #2e3648;"></span> -->
		    			<img src="../static/b1.png" alt="">
		    		</div>
		    	</div>
		        <div class="swiper-slide">
		        	<router-link tag="a" :to="{name:'shoud1'}">
		        		<img src="../static/1.png" alt="">
		        	</router-link>
		        	<div class="towTit">
		    			<!-- <p style="font-size:20px;color:#d4e5a7;margin-bottom:10px;color:#c4d790;font-weight:600;">第二部分</p>
		    			<p style="font-size:20px;color:#96caee;margin-bottom:10px;color:#80b6db;font-weight:600;">帕埃斯图姆的彩绘墓室</p>
		    			<span style="display:inline-block;width:75%;border-bottom:2px solid #2e3648;"></span>
		    			<span style="display:inline-block;width:75%;border-bottom:1px solid #2e3648;"></span> -->
		    			<img src="../static/b2.png" alt="">
		    		</div>
		        </div>
		        <div class="swiper-slide">
		        	<router-link tag="a" :to="{name:'shoud2'}">
		        		<img src="../static/2.png" alt="">
		        	</router-link>
		        	<div class="towTit">
		    			<!-- <p style="font-size:20px;color:#d4e5a7;margin-bottom:10px;color:#c4d790;font-weight:600;">第三部分</p>
		    			<p style="font-size:20px;color:#96caee;margin-bottom:10px;color:#80b6db;font-weight:600;">现实、仪式和幻想的图像</p>
		    			<span style="display:inline-block;width:75%;border-bottom:2px solid #2e3648;"></span>
		    			<span style="display:inline-block;width:75%;border-bottom:1px solid #2e3648;"></span> -->
		    			<img src="../static/b3.png" alt="">
		    		</div>
		        </div>
		    </div>
		 <!--  <div class="swiper-pagination"></div>  -->
		</div>
		<div class="imgtox">
			<p class="title">
				<span style="top:10px">文物展示</span>
				<em style="top:21px;"></em>
			</p>
			<div class="imgbox">
				<dl>
					<dt>
						<router-link tag="a" :to="{name:'artList'}">
							<img src="../static/6.png" alt="">
						</router-link>
					</dt>
					<dd>第一部分</dd>
				</dl>
				<dl>
					<dt>
						<router-link tag="a" :to="{name:'artList1'}">
							<img src="../static/7.png" alt="">
						</router-link>
					</dt>
					<dd>第二部分</dd>
				</dl>
				<dl>
					<dt>
						<router-link tag="a" :to="{name:'shoud3'}">
							<img src="../static/81.png" alt="">
						</router-link>
					</dt>
					<dd>第三部分</dd>
				</dl>
			</div>
		</div>
		 <div class="imgtox">
			<p class="title" style="margin-bottom:20px;">
				<span>全景展示</span>
				<em></em>
			</p>
			<div class="imgbox_360" style="text-align: center;">
				<a href="https://quanjing.artron.net/scene/vnyAuvA85aAoLVbhIhT1chNQYRgMjvoP/chdzh/tour.html"><img src="../static/360.png" alt="" style="width:95%"></a>
				<!-- <div class="mark"></div> -->
			</div>
		</div> 
		<!-- <div class="imgtox">
			<p class="title" style="margin-bottom:20px;">
				<span>视频展示</span>
				<em></em>
				<router-link tag="a" :to="{name:'tList'}">
					<span style="position: absolute;right:0.15rem;color:#999999;background:none">更多视频</span>
				</router-link>
			</p>
			<div class="imgbox_360" style="width:90%">
				<router-link tag="a" :to="{name:'tList'}">
					<img src="../static/video.png" alt="" style="margin-top:50px">
				</router-link>
			</div>
		</div> -->
		<div class="footer">
			<div>
				<p style="margin-bottom:3px;">技术支持：雅昌文化集团</p>
				<p>Techical  support：artron  cultre  group</p>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	import Swiper from 'swiper';
	import 'swiper/dist/css/swiper.min.css';
	import { swiper, swiperSlide } from 'vue-awesome-swiper';
	export default {
		mounted(){
			var tt = window.innerHeight;
			    this.$refs.yuansu.style.height = tt + 'px';
			var mySwiper = new Swiper('.swiper-container',{
				slidesPerView :1.2,
				loop : true,
				centeredSlides : true,
				pagination: {
				    el: '.swiper-pagination',
				},
				spaceBetween :0,
				observer:true,//修改swiper自己或子元素时，自动初始化swiper
				observeParents:true,//修改swiper的父元素时，自动初始化swiper
			})
		}
	}
</script>
<style scoped>
	.towTit{text-align:center;width:80%;margin:0 auto;}
	.towTit p{
		width:75%;
		margin: 0 auto;
		text-align:left;
	}
	.swiper-container{
		margin-top:20px;
	}
	.swiper-slide{
		padding: 0;
		margin: 0;
		/* box-shadow: 10px 10px 10px #e8e8e8; */
	}
	.swiper-slide img{
		width: 100%;
		height: 100%;
		object-fit: contain;
		/* -o-object-fit: contain;
		object-fit: contain;
		box-shadow: 2px 11px 13px #e8e8e8;
		border-radius: 20px; */
	}
	.swiper-pagination-bullets .swiper-pagination-bullet-active{
		background: #e6bb70!important;
	}
	.topbanner{
		width: 100%;
	}
	.topbanner img{
		width: 100%;
		height: 100%;
	}
	.imgtox{
		margin-top: 0.4rem;
	}
	.imgtox .title{
		width: 100%;
		text-align: left;
		font-size:20px;
		position: relative;
	}
	.imgtox .title span{
		text-indent: 0.15rem;
		letter-spacing: 3px;
		font-size: 20px;
		display: inline-block;
		height: 0.2rem;
		line-height: .18rem;
		z-index: 3;
		position: absolute;
		margin-left: 20px;
		background: url(../static/t.png);
		background-size:100% 100%;
		color:#e6bb70;
		font-weight:600;
	}
	.imgtox .imgbox{
		display: flex;
	}
	.imgtox .imgbox dl{
		flex: 1;
	}
	.imgbox dl{
		margin-top:50px;
	}
	.imgbox dl dt{
		height: 1.2rem;
		border-radius: 100%;
		margin: 0 auto;
		text-align:center;
	}
	.imgbox dl dd{
		width: 1.25rem;
		text-align: center;
		margin: 0 auto;
		font-size:18px;
		color: #466c75;
	}
	.imgbox dl dt  img{
		width:100%;
	}
	.imgbox_360{
		width: 95%;
		margin: 0 auto;
		position: relative;
	}
	.imgbox_360 img{
		width: 100%;
		margin-top: 40px;
	}
	.footer{
		height:.4rem;
		width: 100%;
		background:#dfe1de;
		margin-top: -0.6rem;
		padding-top: 1rem;
	}
	.footer div p{
		text-align: center;
		color:#b1b1b1;
	}
	.mark{
		position: absolute;
		width: 100%;
		height: 100%;
		z-index: 9;
		background:rgba(0,0,0,0.5);
		top: 0;
	}
	.swiper-container-horizontal>.swiper-pagination-bullets, .swiper-pagination-custom, .swiper-pagination-fraction{bottom: 60px;}
</style>